var $ = jQuery;

$.extend($.expr[":"], {
"containsNC": function(elem, i, match, array) {
return (elem.textContent || elem.innerText || "").toLowerCase().indexOf((match[3] || "").toLowerCase()) >= 0;
}
});

function detectIE() {
  var ua = window.navigator.userAgent;

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  /*if (edge > 0) {
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }*/

  return false;
}

	(function($) {
	$.fn.visible = function(partial) {
		var $t			= $(this),
		$w			= $(window),
		viewTop		= $w.scrollTop(),
		viewBottom		= viewTop + $w.height(),
		_top			= $t.offset().top + 70,
		_bottom		= _top + $t.height(),
		compareTop		= partial === true ? _bottom : _top,
		compareBottom	= partial === true ? _top : _bottom;

		return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
	  };
	})(jQuery);

	function getCurrentScroll() {
		return window.pageYOffset || document.documentElement.scrollTop;
	}
	function forEach(ctn, callback) {
		return Array.prototype.forEach.call(ctn, callback);
	}

	var resizeTimer,
	page,
	$w = $(window),
	$h = $('header'),
	$n = $h.find('nav'),
	$mobileNav = 0,
	lastScroll = 10,
	stopTime = false;

	var cookiesInit = function(){
		setTimeout(function() {
			if($('.cookieWrap').length > 0) {
				$('html').addClass('show-cookies');
			}
		}, 1000);
	}

	var debounce = function(e){
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function() {
			page.isMobile();
		}, 350);
	};

	var checkScrollTop = function(){
		var dtop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
		if($body.hasClass('iPad') || $body.hasClass('iPhone')) {
			$h.addClass('fixed-navigation');
			$('.backtotop').removeClass('hidden');
		} else {
			if(dtop > 300 && $w.width() > 600) {
				$h.addClass('fixed-navigation');
				$('.backtotop').removeClass('hidden');
			} else if (dtop > 100 && $w.width() < 600) {
				$h.addClass('fixed-navigation');
				$('.backtotop').removeClass('hidden');
			} else {
				$h.removeClass('fixed-navigation');
				$('.backtotop').addClass('hidden');
			}
		}
	}
	var checkPosition = function(){

			var top = $w.scrollTop(),
			height = $w.height();

			if(top < 1) {
				$h.removeClass('fade-out');
			} else {
				$h.addClass('fade-out');
			}

			$(".services").each(function(i, el) {
			var el = $(el);
			if (el.visible(true)) {
				if(!$(this).hasClass('animate')){
					$(this).addClass('animate');
					$('.btn-services').addClass('animate');
				}
			}
		 });

	};

$(document).ready(function(){

	setTimeout(function() {
		$('html').addClass('documentLoaded');
	}, 10);


	if(detectIE() != false){
		$('body').addClass('IE');

		$('.leistung.leistungRight .main').each(function(){
			var self = this;
			$(self).parent().prepend(self);
		});

		setTimeout(function () {
			objectFitImages();

			$('.rowitem--image--right').each(function(){
				var self = this;
				$(self).height($(self).prev().outerHeight());
			});
		}, 100);
	}

	if(typeof app != 'undefined') {
		for(var f in app.require){
			app.require[f]();
		};
	};

	page = {
		src: "data-desktop-src",
		mobile: false,
		$masterWrap: $('#masterWrap'),
		init: function(){
			var self = this;
			self.initScrollNav();
			self.bindHandlers();

			self.initFancyBox();
			//self.initFormFuncs();
			self.initPictures();
			// self.initCookies();
			self.initSlider();
			self.initMailPoetFuncs();

			self.initWelcome();
			self.initVereinsregister();
			self.initVeranstaltungskalender();
			self.initContestgallery();
			self.initComments();

			// fb_barrierefreiheit 
			bf.init();

			setTimeout(function () {
				self.initKimeta();
			}, 300);

			self.isMobile();
			// checkPosition();

		},
		bindHandlers: function(){
			var self = this;

			window.addEventListener('scroll', checkPosition);
			window.addEventListener('resize', debounce);


			$('.trigger').click(function(e){

				if($(this).hasClass('magazin')) {
					$body.toggleClass('mag-show');
					$body.removeClass('search-show');
					if($body.hasClass('active-menu')) {
						$body.removeClass('active-menu');
					}

					// if magazine is open -> focus first a
					if($body.hasClass('mag-show')) {
						console.log('magazin open');
						setTimeout(function() {
							console.log('magazin open?');
							$('.header-magazin a').first().focus();
						}, 500);
					}	
				}
				if($(this).hasClass('search')) {
					$body.toggleClass('search-show');
					$body.removeClass('mag-show');
					if($body.hasClass('active-menu')) {
						$body.removeClass('active-menu');
					}

					// if search is open -> focus input
					if($body.hasClass('search-show')) {
						setTimeout(function() {
							$('.search-field').focus();
						}, 500);
					}
				}
				e.preventDefault();
			});


			// listen to ESC-Key - if search or magazine is open, close it
			$(document).keyup(function(e) {
				if (e.keyCode === 27) { // ESC
					if($body.hasClass('search-show')) {
						$body.removeClass('search-show');
						$('.search-field').blur();
					}
					if($body.hasClass('mag-show')) { 
						$body.removeClass('mag-show');
						$('.header-magazin a').blur();
					}
					// focus trigger
					$('.trigger').first().focus();
				}
			});

			$('a[href^="#"]').not('.cg_show_form_trigger, .fbevents--list--item--wrap, .fbevents--list--item--more, .eventlink').on('click', function(e) {
				var target = this.hash;
				var $target = $(target);
				if(target.length > 1 && $target.length) {
					e.preventDefault();
					$('html, body').stop().animate({
						'scrollTop': $target.offset().top - 100
					}, 900, 'swing', function() {
						window.location.hash = target;
					});
				}
			});

			//Click event to scroll to top
			$('.backtotop').click(function(e){
				$("html, body").animate({ scrollTop: 0 }, "slow");
				$('.backtotop').addClass('hidden');
				e.preventDefault();
			});

			$('li.menu-item-has-children > a').click(function(e){
				e.preventDefault();
				// $(this).addClass('dropdownShow');
				var  self = this;
				// if ($('#masterWrap').hasClass('mobile-state')) {
				// 	$(self).children('.subbutton').trigger("click");
				// }
			});

			//*Fixed Navigation & BackToTop button
			window.addEventListener('scroll', function(e){
				checkScrollTop();  //Check bei Scroll
			});
			checkScrollTop(); //Check bei Page-Load


			$(".menu-item-has-children").hover(function(e){
				if (page.mobile != true) {
					var $el = $(this),
					elc = $el.width()/2,
					$subnav = $el.find('.sub-menu'),
					subc = $subnav.width()/2;

					$subnav.css({ left: -(subc-elc)+'px' });
				}
			});



		},
		initPictures: function(){

		},
		initMailPoetFuncs: function(){

			if ($('.mailpoet_submit').length) {
				$('.mailpoet_submit').click(function(e){
					$(this).parent().parent().addClass('form-is-loading')
						if ($('.hide').data('oldmail') != '' && $('[name="data[form_field_ZW1haWw=]"]').val() != '' && $('[name="data[cf_1]"]').is(':checked')) {
							$.ajax({
								url: '/wp-content/themes/darmstadtimherzen/inc/mailpoetProcess.php',
								type: 'post',
								data: {
									"newmail": $("[title^='E-Mail']").val(),
									"oldmail": $('.hide').data('oldmail')
								},
								success: function(response) {
									//console.log(response);
								}
							});
						}
				});

				if(window.Parsley) {
					window.Parsley.on('field:error', function() {
						$('.mailpoet_submit').parent().parent().removeClass('form-is-loading')
					});
				}
			}

		},
		initFormFuncs: function(){
			var hash = window.location.hash;
			var n = hash.search("contact-form");
			var f = hash.search("contactform");

			if(n > 0 || f > 0) {

				var elementTop = $('#contact').offset().top;

					$('body,html').animate({
						scrollTop: elementTop
					}, 500);

				$('.meta-fancy-btn.contactform').click();
				window.location.hash = 'contactform';

			}


			//Close open Fancybox with Browser Back Button
			window.onhashchange = function() {
				if($('html').hasClass('fancybox-enabled')){
					var instance = $.fancybox.getInstance();
					instance.close();
				}
			}


		},
		initScrollNav: function(){

			$(document).on('click', '#navMain li.scroll-to a, a.scroll-to, a.scrollto-btn', function(e){

				var elementNav = $(this).attr('href');
				var elementTop = $(''+elementNav+'').offset().top;
				var tempo = 1000;
				var top = $w.scrollTop();

				var scrollLength = elementTop - top;

				if(scrollLength > 2500){
					var tempo = 1500;
				}
				if(scrollLength > 5000){
					var tempo = 2000;
				}


				$('#header').addClass('fade-out');
				var hh = $h.height();

				$('body,html').animate({
					scrollTop: elementTop-(hh*2)

				}, tempo, function() {
				// Animation complete.
				});

				if($('#header').hasClass('active-menu')){
					$('#header').removeClass('active-menu');
				}

				window.location.hash = elementNav;
				e.preventDefault();

			});
		},
		initFancyBox: function(){

			function initFancybox(){
				$(this).fancybox({
					'autoScale': true,
					'transitionIn': 'elastic',
					'transitionOut': 'elastic',
					'speedIn': 500,
					'speedOut': 300,
					'autoDimensions': true,
					'centerOnScroll': true,
					btnTpl: {
						smallBtn:
							'<a data-fancybox-close class="fancybox-button fancybox-button--close foto-contest" title="{{CLOSE}}">' + 'x' +	"</a>"
					}
				});
			}
			// $('rowitem--link').fancybox({
			// 	helpers: {
			// 		overlay: {
			// 			locked: false
			// 		}
			// 	}
			// });

			$('.gallery a').fancybox({
				'autoScale': true,
				'transitionIn': 'elastic',
				'transitionOut': 'elastic',
				'speedIn': 500,
				'speedOut': 300,
				'autoDimensions': true,
				'centerOnScroll': true,
				btnTpl: {
					smallBtn:
						'<a data-fancybox-close class="fancybox-button fancybox-button--close foto-contest" title="{{CLOSE}}">' + 'x' +	"</a>"
				}
			});
		},
		initSlider: function(){
			$('.veranstaltungen .owl-carousel').owlCarousel({
			    loop: false,
			    margin:10,
			    nav:true,
				autoplay: true,
			     responsiveClass:true,
			responsive: {
				0:{
					items: 1,
				},
				560:{
					items: 2,
				},
				960:{
					items: 3,
				},
			},
				items: 3,
				// autoplay: true,
				navigation: false,
				dots: false,				
				onInitialized: function(e){
					$(e.target).addClass('owl-carousel');
					// owl-next, owl-prev - aria-labels
					$(e.target).find('.owl-next').attr('aria-label', 'Nächster Slide').removeAttr('role').find('span').removeAttr('aria-label');
					$(e.target).find('.owl-prev').attr('aria-label', 'Vorheriger Slide').removeAttr('role').find('span').removeAttr('aria-label');
				},
				onChange: function(e){
					setTimeout(() => {
						// only active children should be focusable
						$(e.target).find('.owl-item.active').find('a').each(function(){								
							// remove tabindex from all children
							$(this).removeAttr('tabindex');
						});
						// set tabindex to inactive children
						$(e.target).find('.owl-item:not(.active)').find('a').each(function(){
							// set tabindex to all children
							$(this).attr('tabindex', '-1');
						});							
					}, 300);
				}
			});
			$('#lebenswelten > div').owlCarousel({
			    loop: false,
			    // margin:10,
			    // nav:true,
				items: 1,
				animateOut: 'fadeOut',
				autoplay: true,
				navigation: false,
				pagination: true,
				onInitialized: function(event) {
					owlOnInitializedHook(event);
				},
				onChange: function(event) {
					owlOnChangeHook(event);
				}
			});
			$('.rowslider > div').owlCarousel({
			    loop: false,
			    margin:19,
			    // nav:true,
			 responsiveClass:true,
			responsive: {
				0:{
					items: 2,
				},
				560:{
					items: 3,
				},
				960:{
					items: 4,
				},
			},
				items: 4,
				animateOut: 'fadeOut',
				autoplay: true,
				navigation: false,
				dots: false,
				onInitialized: function(event) {
					owlOnInitializedHook(event);
				},
				onChange: function(event) {
					owlOnChangeHook(event);
				}
			});
			$('.gallery').each(function(){
				var self = this;
				var items = 3;
				if ($(self).data('items')) items = $(self).data('items');
				var pag = false;
				if ($(self).children().length > items) pag = true;
				// $(this).addClass('own-carousel');
				//console.log($(self).data('items'))
				if($(this).hasClass('tinygallery')) {
					$(this).owlCarousel({
					    loop: false,
					    nav:false,
						dots:false,
						autoplay:true,
						autoplayTimeout:3500,
						animateOut: 'fadeOut',
						items: $(self).data('items'),
						navigation: false,
						pagination: false,
						onInitialized: function(event) {
							owlOnInitializedHook(event);
						},
						onChange: function(event) {
							owlOnChangeHook(event);
						}
					});
				} else {
					$(this).owlCarousel({
						// loop: true,
						nav:false,
						items: $(self).data('items'),
						// autoplay: true,
						navigation: false,
						pagination: pag,
						onInitialized: function(event) {
							owlOnInitializedHook(event);
						},
						onChange: function(event) {
							owlOnChangeHook(event);
						}
					});
				}
			});
		},
		initCookies: function(){
			cookie();
			setTimeout(function() {
				if($('.cookieWrap').length > 0) {
					$('html').addClass('show-cookies');
				}
			}, 3000);
		},

		initWelcome: function(){
			var $rp = $('.recent-posts');

			var toPreload = '';
			$('.recent-posts--item').each(function(){
				// if (page.mobile) {
				// 	toPreload.push($(this).data('smallimage'));
				// } else {
				// 	toPreload.push($(this).data('image'));
				// }
				// toPreload += $(this).data('image')+', ';
				preload($(this).data('image'));
			});
			// console.log(toPreload);

			if($rp.length) {
				$('.recent-posts--item:nth-of-type(1)').addClass('active');
				$('.recent-posts--item').not(':first-of-type').each(function(e){
					var imgHTML = '<img class="headerbild" src="'+$(this).data('image')+'" alt="Header Bild"/>';
					$('.header-image').append(imgHTML);
				});
				setInterval(function () {
					// $rp.addClass('transition');
					$('.recent-posts--item').removeClass('active');
					
					$('.recent-posts--item:nth-of-type(1)').detach().insertAfter($('.recent-posts--item:nth-of-type(3)'));
					$('.recent-posts--item:nth-of-type(1)').addClass('active');
					
					setTimeout(function () {
						$('.header-image img.active');
						if($('.header-image img.active').next().length) {
							$('.header-image img.active').fadeOut().removeClass('active').next().addClass('active').fadeIn();
						} else {
							$('.header-image img.active').fadeOut().removeClass('active');
							$('.header-image img:first-of-type').addClass('active').fadeIn();
						}
						// $rp.removeClass('transition');
					}, 100);
				}, 7100); //7100
			}
			var $ytt = $('.zugastbei .youtubetrigger');
			if($ytt.length) {
				$ytt.click(function(e){
					e.preventDefault();
					var self = this;
					$('.zugastbei').addClass('transition');
					$('.zugastbei .rowitem:nth-of-type(1) video').each(function () {
						this.currentTime = 0;
						this.pause();
					});
					$('.zugastbei .rowitem:nth-of-type(1)').addClass('transition');
					$(self).parent('.rowitem').addClass('transition');
					setTimeout(function () {
						$(self).parent('.rowitem').detach().insertBefore($('.zugastbei .rowitem:nth-of-type(1)'));
					}, 300);
					setTimeout(function () {
						$('.zugastbei .rowitem').removeClass('transition');
					}, 1000);
				});
			}
		},
		internetexplorer: function(){
			console.log('internetexplorer');
		},
		initKimeta: function(){

			// welcome small form to kimeta page
			var $btn = $('.jobbox button');
			if ($btn.length) {
				// $btn.attr('onclick', ''); // disable kimeta function
				$btn.click(function(e){
					e.preventDefault();
					// send data to template
					var values = '';
					// if ($('#KimetaInABox #Inhalt').val() != '') values += '?job=' + encodeURI($('#KimetaInABox #Inhalt').val());
					// if (values != '' && $('#KimetaInABox #Einsatzort').val() != '') values += '&place=' + encodeURI($('#KimetaInABox #Einsatzort').val());
					// if (values != '' && $('#KimetaInABox #Umkreis').val() != '') values += '&range=' + encodeURI($('#KimetaInABox #Umkreis').val());
					if ($('.jobbox input').val() != '') values += '?job=' + encodeURI($('.jobbox input').val());

					var url = '/karriere-in-darmstadt' + values;
					window.location.href = url;
				});
				$('.jobbox input').on('keyup', function (e) {
				    if (e.keyCode == 13) {
						var values = '';
				        if ($('.jobbox input').val() != '') values += '?job=' + encodeURI($('.jobbox input').val());
						var url = '/karriere-in-darmstadt' + values;
						window.location.href = url;
				    }
				});
			}

			// get request on template
			if ($('#kimeta').length) {

				var $kimetabtn = $('#kimetaSubmit');
				$kimetabtn.click(function(e){
				});

				var job = getUrlParameter('job');
				if (job) $('#Inhalt').val(job);
				var place = getUrlParameter('place');
				if (place) $('#Einsatzort').val(place);
				var range = getUrlParameter('range');
				if (range) $('#Umkreis').val(range);

				$kimetabtn.trigger('click');
				var topOffset = $('#kimeta').offset().top;
				if (job || place || range) $('body,html').animate({	scrollTop: topOffset - 50 }, 500);

				$('#kimeta').on('click', '#kimetaSubmit', function() {
					var values = '';
					if ($('#Inhalt').val() != '') values += '?job=' + encodeURI($('#Inhalt').val());
					if (values != '' && $('#Einsatzort').val() != '') values += '&place=' + encodeURI($('#Einsatzort').val());
					if (values != '' && $('#Umkreis').val() != '') values += '&range=' + encodeURI($('#Umkreis').val());
					var url = '/karriere-in-darmstadt' + values;
					history.pushState(null, "New job search params", url);
				});
			}
		},
		initComments : function(){
			if ($('.comments').length) {
				$('.comments--more').click(function(e){
					e.preventDefault();
					$('.comments--item.hide').removeClass('hide');
					$(this).hide();
				})
			}
		},
		initContestgallery: function() {
			var self = this;
			if($('.cg_show_form_trigger_wrap').length){
				// console.log('cg_show_form_trigger_wrap.length');
				// $('.cg_show_form_trigger').click(function(e){
				// 	e.preventDefault();
				// 	$('#cg_upload_form_container').removeClass('hidden');
				// })
				$('.cg_show_form_trigger').fancybox({
					btnTpl: {
						smallBtn:
							'<a data-fancybox-close class="fancybox-button fancybox-button--close foto-contest" title="{{CLOSE}}">' + 'x' +	"</a>"
					}
		        });
			}

			// local storage vars um menge an bildupload etwas zu limiten
			if ($('#cg_success').length) {
				var count = 0;
				if (localStorage.getItem('fc-uploaded')) count = localStorage.getItem('fc-uploaded');
				count++;
				localStorage.setItem('fc-uploaded', count);

				// var html = '<div style="display:none;"><div id="fotosuccess--app" class="bg-primary">';
				// 	html += '<h3>APP!</h3>';
				// html += '</div></div>';

				// $('#cg_success').append(html);
				// $.fancybox.open({ // FancyBox 3
				// 	src: '#fotosuccess--app',
				// 	btnTpl: {
				// 		smallBtn:
				// 			'<a data-fancybox-close class="fancybox-button fancybox-button--close foto-contest" title="{{CLOSE}}">' + 'x' +	"</a>"
				// 	}
				// });
			}
			if (localStorage.getItem('fc-uploaded') > 1) {
				$('.cg_show_form_trigger').hide();
				$('.cg_show_form_trigger_wrap').css('margin-bottom', '2%');
				$('.cg_show_form_trigger_wrap p').fadeIn();
			}

			// uploadform popup trigger by url param
			var uploadform = getUrlParameter('uploadform');
			if (uploadform == 'true') {
				setTimeout(function () {
					$('.cg_show_form_trigger').trigger('click');
				}, 200);
			}

			// check der gevoteten elemente for andere css darstellung, kommen nach, daher mit timeout
			setTimeout(function () {
				$('.cg_gallery_rating_div_count').each(function(e){
					if(this.innerHTML == '1') {
						$(this).prev('div').addClass('starred');
						$(this).parents('a').children('.cg_append').addClass('starred');
					}
				});
				$('.cg-center-image-div').on('click', '.cg_rate_star', function(){
					var star = this;
					setTimeout(function () {
						var id = $(star).data('cg_rate_star_id');
						var el = '#rating_cg-' + id;
						var go = false;

						if($(el).get(0).innerHTML == '1') go = true;
						if(go) {
							var data = '*[data-cg_rate_star_id="'+id+'"]';
							var idsmall = '#cg_append'+id;
							$(data).addClass('starred');
							$(idsmall).addClass('starred');
						}
					}, 2000);
				});
				var trigger = new ScrollTrigger({
					toggle: {
						visible: 'visibleClass',
						hidden: 'hiddenClass'
					},
					offset: {
						x: 0,
						y: 40
					},
					addHeight: false,
					once: true
				}, document.body, window);
			}, 600);


			// check for max filesize
			$('#cg_input_image_upload_id').bind('change', function(e) {
				var maxSIZE = 2; // mb
				var imageinput = $('#cg_input_image_upload_id');
				var size = this.files[0].size/1024/1024;
				size = size.toFixed(2);
				if(size > maxSIZE) {
					alert('Das Bild ist zu groß ( '+ size + 'MB ), bitte reduziere die Dateigröße und versuch es nochmal. ( Max. Dateigröße beträgt '+ maxSIZE +' MB ). ');
					imageinput.val('').replaceWith( imageinput = imageinput.clone( true ) );
				}
			});

			// wenn js check umgangen wurde und von php redirected wurde nachricht anzeigen // IE fix?
			var url_string = window.location.href;
			var url = new URL(url_string);
			var e = url.searchParams.get("error");
			if (e == 'filesize') {
				$('.cg_show_form_trigger_wrap p').text('Ihr Bild hat die maximale Dateigröße (2 MB) überschritten. Bitte reduzieren Sie die Dateigröße.').css('color', 'red').fadeIn();
			}

		},
		initVereinsregister: function() {
			if ($('#vereinsregister').length) {
				var init = $('#vereinsregister').data('init');
				if(init) {
					$('#vereinsregister li').addClass('hide');
					$('#vereinsregister li.'+init).removeClass('hide');
					$('*[data-cat="'+init+'"]').removeClass('active');
				}
				$('#search').on('input', function() {
					var val = $(this).val();
					if (val.length > 2) {
						$('.vereinsmenu a').removeClass('active');
						$('#vereinsregister li').addClass('hide');
						$( ".vereinsregister--title:containsNC('"+val+"')" ).parent('li').removeClass('hide');
						$( ".vereinsregister--depts:containsNC('"+val+"')" ).parent('li').removeClass('hide');
						$( ".vereinsregister--search:containsNC('"+val+"')" ).parent('li').removeClass('hide');
					} else {
						$('#vereinsregister li').removeClass('hide');
					}
				});
				if(getUrlParameter('q') != '') {
					$('.vereinsmenu a[data-cat="'+getUrlParameter('q')+'"]').addClass('active');
				}
				$('.vereinsmenu a').click(function(e){
					e.preventDefault();
					if ($(this).data('cat')) {
						var cat = $(this).data('cat');
						$('.vereinsmenu a').removeClass('active');
						$(this).addClass('active');
						$('#vereinsregister li').addClass('hide');
						$('#vereinsregister li.'+cat).removeClass('hide');
					} else {
						$('.vereinsmenu a').removeClass('active');
						$(this).addClass('active');
						$('#vereinsregister li').removeClass('hide');
					}
				});
			}
		},
		initVeranstaltungskalender: function(){
			var self = this;
			if ($('#caleandar').length) { // Kalender ansicht
				const clicks = [];
				const $sb = $('#fbevents--selectbox');
				let done = false;
				eventclick = function(url){
					$sb.html('');
					clicks.push(url);
					setTimeout(function () {
						if (clicks.length > 1 && !done) {
							done = true;
							let date = '';
							let html = '<div class="fbevents--selectbox--wrapper">';
								for (var i = 0; i < clicks.length; i++) {
									const u = clicks[i];
									date = $(clicks[i]).find('.fbevents--list--item--date .start .date').text();
									const t = $(clicks[i]).find('.fbevents--list--item--title').text();
									html += '<a href="'+u+'" data-fancybox class="fbevents--selectbox--button">'+t+'</a>';
								}
							date = (date != '' ? ' <mark>am '+date+'</mark>' : '');
							html += '<span class="fbevents--selectbox--title">Zu welcher Veranstaltung'+date+' wollen Sie weitere Informationen erhalten?</span>';
							html += '</div>';
							$sb.html(html);
							$.fancybox.open({ // FancyBox 3
								src: '#fbevents--selectbox',
								touch: false,
								btnTpl: {
									smallBtn:
										'<a data-fancybox-close class="fancybox-button fancybox-button--close foto-contest" title="{{CLOSE}}">' + 'x' +	"</a>"
								}
							});
							setTimeout(function () {
								clicks.length = 0;
								done = false;
							}, 200);
						} else if (clicks.length > 1 && done) {
							// do nothing
						} else {
							clicks.length = 0;
							$.fancybox.open({ // FancyBox 3
								src: url,
								touch: false,
								btnTpl: {
									smallBtn:
										'<a data-fancybox-close class="fancybox-button fancybox-button--close foto-contest" title="{{CLOSE}}">' + 'x' +	"</a>"
								}
							});
						}
					}, 200);
				};
				// check if too many events in one day (custom "callback" -> dom change observer)
				const obs = new MutationObserver(function(cs){
					cs.forEach(function(c){
						(c.addedNodes.length ? checkClickableDays() : false);
					})
				});
				obs.observe(document.getElementById('caleandar'), {childList:true});
				function checkClickableDays() {
					const clickables = document.querySelectorAll('.cld-day');
					const maxevents = 3;
					for (var i = 0; i < clickables.length; i++) {
						const clcount = (clickables[i].classList.value.match(/clickable/g) || []).length;
						if (clcount > maxevents) {
							clickables[i].classList.add('extraevents');
							clickables[i].setAttribute('data-extraevents', clcount - maxevents);
							clickables[i].setAttribute('data-eventcount', clcount);
						}
					}
					setTimeout(function () {
						document.querySelector('.cld-days').classList.add('showdays');
					}, 50);
				}
				// view mode toggle
				$('.fbevents--switch > a').click(function(e){
					e.preventDefault();
					var target = $(this).attr('data-target');
					if (target != $('.fbevents--switch').attr('data-active')) {
						$('.fbevents--switch').attr('data-active', target);
						$('[data-view="'+target+'"]').stop(true, true).animate({
				            height:"toggle",
				            opacity:"toggle"
				        },600);
						$('[data-view]').not('[data-view="'+target+'"]').stop(true, true).animate({
				            height:"toggle",
				            opacity:"toggle"
				        },600);
					}
				});
				const settings = {
				    Color: '',
				    LinkColor: '',
				    NavShow: true,
				    NavVertical: false,
				    NavLocation: '',
				    DateTimeShow: true,
				    DateTimeFormat: 'mmm, yyyy',
				    DatetimeLocation: '',
				    EventClick: eventclick,
				    EventTargetWholeDay: true,
				    DisabledDays: [],
				};
				caleandar(document.getElementById('caleandar'), events, settings);
			}
			$('a.fbevents--list--item--wrap, .fbevents--list--item--more, .eventlink').click(function(e){
				e.preventDefault();
				e.stopPropagation();
				const url = $(this).attr('href');
				$.fancybox.open({ // FancyBox 3
					src: url,
					touch: false,
					btnTpl: {
						smallBtn:
							'<a data-fancybox-close class="fancybox-button fancybox-button--close foto-contest" title="{{CLOSE}}">' + 'x' +	"</a>"
					}
				});
				return false;
			});
			if ($('.fbevents--list').length) {
			}
		},
		isMobile: function(cb){
			var self = this;
			extraMenuCtrl.init();

			var device = detectDevice.any();
			if (device) {
				$body.addClass(detectDevice.any()[0]);
			}

			// ipad fix?
			if($body.hasClass('iPad') || $body.hasClass('iPhone')) {
				$h.addClass('fixed-navigation');
				$('.backtotop').removeClass('hidden');
			}

			if($w.width() <= 680){
			/*Mobile Navi Init*/

			self.mobile = true;
			self.$masterWrap.addClass('mobile-state');

			}else{
				self.mobile = false;
				self.$masterWrap.removeClass('mobile-state');
			}
      		},
	}

	page.init();
});




var images = new Array();
function preload() {
	for (i = 0; i < preload.arguments.length; i++) {
		images[i] = new Image()
		images[i].src = preload.arguments[i];
	}
}


var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};


var detectDevice = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile|Chrome|Mozilla/i);
    },
    any: function() {
		var self = this;
        return (self.Android() || self.BlackBerry() || self.iOS() || self.Opera() || self.Windows());
    }
};



	function owlOnInitializedHook(e){
		// owl-next, owl-prev - aria-labels
		$(e.target).find('.owl-next').attr('aria-label', 'Nächster Slide').removeAttr('role').find('span').removeAttr('aria-label');
		$(e.target).find('.owl-prev').attr('aria-label', 'Vorheriger Slide').removeAttr('role').find('span').removeAttr('aria-label');

		// owl-dots
		$(e.target).find('.owl-dots').attr('role', 'tablist').find('.owl-dot').each(function(index){
			$(this).attr('role', 'tab');
			$(this).attr('aria-label', 'Slide ' + (index + 1));
			$(this).find('span').removeAttr('aria-label');
		});		
	}

	function owlOnChangeHook(e){
		setTimeout(() => {
			// only active children should be focusable
			$(e.target).find('.owl-item.active').find('a').each(function(){								
				// remove tabindex from all children
				$(this).removeAttr('tabindex');
			});
			// set tabindex to inactive children
			$(e.target).find('.owl-item:not(.active)').find('a').each(function(){
				// set tabindex to all children
				$(this).attr('tabindex', '-1');							
			});							
		}, 300);
	}